<template>
  <div>
    <div class="pdp-quantity-and-size">
      <label
        for="quantity"
        class="description text-uppercase font-weight-bold"
        >{{ $resourceString["pdp.aside.bottom.quantity"] }}</label
      >
      <input
        name="quantity"
        type="number"
        min="1"
        :max="trustedUser.quantityInStock"
        v-model="quantity"
        class="mb-2 form-control"
        @change="onQuantityChange($event)"
      />
    </div>
    <button
      type="button"
      :class="'wf-add-to-cart-button ' + cssClasses"
      @click="addItemToCart"
      :disabled="OrderSampleEnabled"
    >
      <slot>
        <span :class="'png-icon png-icon-' + iconName"> </span>
        <span class="ml-2">
          {{ buttonText }}
        </span>
      </slot>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      vehicleId2: "",
      quantity: 1,
      defaultQty: 10
    };
  },
  props: {
    sellingStyleNumber: {
      type: String,
      required: true
    },
    colorNumber: {
      type: String,
      required: true
    },
    vehicleId: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Add sample to basket"
    },
    cssClasses: {
      type: String,
      default: "btn btn-primary"
    },
    iconName: {
      type: String,
      default: "icons-glyph--ko-my-basket"
    },
    trustedUser: {
      type: Object,
      required: true,
      default() {
        return {
          isTrustedUser: false,
          quantityInStock: 10
        };
      }
    },
    productIndex: 0
  },
  created() {
    this.isOrderSampleEnabled()
    if (
      this.selectedColor &&
      this.selectedColor.samples &&
      this.selectedColor.samples.length
    ) {
      this.vehicleId = this.selectedColor.samples[0]?.vehicleId;
    }
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      OrderSampleEnabled :"productDetail/getisOrderSampleEnabled"

    })
  },
  methods: {
    ...mapActions({
      addToCart: "newBasketPage/addToCart",
      isOrderSampleEnabled:"productDetail/isOrderSampleEnabled"

    }),
    addItemToCart() {
      let data = {
        sellingStyleNumber: this.sellingStyleNumber,
        colorNumber: this.colorNumber,
        vehicleId: this.vehicleId,
        quantity: this.quantity,
        saveForLater: false
      };
      this.addToCart(data);
    },
    onSizeChange: function(e) {
      this.vehicleId = e.target.value;
    },
    onQuantityChange: function(e) {
      if (e.target.value > this.trustedUser.quantityInStock) {
        this.quantity = this.trustedUser.quantityInStock;
      } else {
        this.quantity = e.target.value;
      }
    }
  }
};
</script>
